export default {
    production: false,
    apiUrl: "https://webservices.transexpress.com.gt/api/",
    apiUrlLumen : "https://webservices.transexpress.com.gt/lumen/",
    publicUrl: "https://webservices.transexpress.com.gt",
    altfinger: Math.random().toString(36).substr(2, 9)
};
